import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';
import { notForPreview } from 'widget/utils/not-for-preview';

import { canShowMainItemPublisher, canShowMainItemTitle } from 'shared/selectors/app-settings';

import OverlayStripBase from './strip-base';
import { RoundedIcon } from 'shared/components/icon/icon';
import { GenericButton } from 'shared/components/button/button';
import ResizedImage from 'shared/components/resized-image/resized-image';

import styles from './member-only.styl';


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayStripMemberOnly extends OverlayStripBase {

  static displayName = 'OverlayStripMemberOnly';
  static propTypes = {
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    buttonsWrapperClassName: React.PropTypes.string,
  };

  @autobind
  @notForPreview
  callPlayCallback() {
    const { videoItem: { id }, onPlayClick } = this.props;
    onPlayClick(id);
  }

  get playButton() {
    const playButtonText = this.playButtonText;

    if (!playButtonText) {
      return null;
    }

    return (
      <GenericButton styleName="button play-button"
                     onClick={this.callPlayCallback}
                     className="qa-widget-overlay-play-button">
        <RoundedIcon styleName="icon play-icon"
                     name="arrow-right-filled" />
        <span styleName="text">
          {playButtonText}
        </span>
      </GenericButton>
    );
  }


  get buttons() {
    const { buttonsWrapperClassName } = this.props;

    return (
      <div styleName="buttons-wrapper"
           className={buttonsWrapperClassName}>
        {this.playButton}
      </div>
    );
  }

  get coverUrl() {
    const { videoItem, channelData } = this.props;

    let coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

    if (this.isChannelCoverView) {
      coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
    }

    return coverUrl;
  }

  render() {
    const { className, width, height } = this.props;

    return (
      <div styleName="wrapper">
        <ResizedImage src={this.coverUrl}
                      width={width}
                      height={height}>
          <div styleName="overlay"
               className={className}>
            <div styleName="content">
              <div styleName="top-content"
                   className="qa-player-overlay">
                {this.publisher}
                {this.title}
                {this.buttons}
              </div>
            </div>
          </div>
        </ResizedImage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/strip/member-only.js